
import { ApiProperty } from "@nestjs/swagger";


export class EmployeeCodeRequest {
    @ApiProperty()
    employeeCode: string;

    constructor(employeeCode: string) {
        this.employeeCode = employeeCode
    }
}